import { apiGet } from './api';

export interface NewsItem {
  id: number;
  title: string;
  subTitle?: string;
  image?: string | null;
  html: string;
  createdDate: string;
}

/** GET /Events/news — noticias (publico) */
export const getNews = () => apiGet<NewsItem[]>('/Events/news');

/** GET /Events/news/{id} — uma noticia especifica */
export const getNewsById = (id: number | string) =>
  apiGet<NewsItem>(`/Events/news/${encodeURIComponent(String(id))}`);
